/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_Item_AccessInputs */

const en_terms_section_4_item_access = /** @type {(inputs: Terms_Section_4_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not try to reach any part of the site or its systems you have not been given access to.`)
};

const lv_terms_section_4_item_access = /** @type {(inputs: Terms_Section_4_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemēģināt piekļūt tīmekļvietnes vai tās sistēmu daļām, kurām piekļuve nav dota.`)
};

/**
* | output |
* | --- |
* | "Not try to reach any part of the site or its systems you have not been given access to." |
*
* @param {Terms_Section_4_Item_AccessInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_item_access = /** @type {((inputs?: Terms_Section_4_Item_AccessInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_Item_AccessInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_item_access(inputs)
	return en_terms_section_4_item_access(inputs)
});